<template>
  <v-chip
    v-bind="chipProps"
    class="font-weight-bold"
    v-on="$listeners"
  >
    <span :class="{ strike }">
      {{ label }}
    </span>
  </v-chip>
</template>

<script>
export default {
  name: 'ReferenceTagChip',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    strike: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chipProps() {
      const props = {
        ...this.$attrs,
        color: this.color,
      };
      if (this.size) {
        props[this.size] = true;
      }
      return props;
    },
  },
};
</script>

<style lang="scss" scoped>
.strike {
  text-decoration: line-through;
}
</style>
